// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uo","itemWrapper":"up s4","itemStyle":"uq s5"};